import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-accordion',
	styleUrls: ['./accordion.component.css'],
	templateUrl: './accordion.component.html'
})
export class AccordionComponent implements OnInit {
	@Input() title: string;

	@Input() index: string;

	@Input() active;

	@Input() className: string;

	@Output() toggleAccordion: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	ngOnInit(): void {}

	onClick(event: any, index: any): void {
		event.preventDefault();
		EmitterService.get('UPDATE_INDEX').emit(index - 1);
		this.toggleAccordion.emit(this.active);
	}
}
